export const Resume = ({ expand, expandableRef4 }) => {
    return <section className="resume expandable" onClick={expand} ref={expandableRef4}>
        <h1 className="first">Reesume</h1>
        <div className="expandable-data">
            <div className="header">
                <p>gaya shayo</p>
                <p>resume</p>
                <p>graphic designer</p>
            </div>
        </div>
    </section>
}